import { render, staticRenderFns } from "./TermsAndConditionsDe.vue?vue&type=template&id=1954daf1&"
import script from "./TermsAndConditionsDe.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsDe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports